import { useEffect, useState } from 'react';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { GoogleIntegration } from '../../../commonTypes/user.types';
import { AppError, ErrorCodes, isErrorCode } from '../../../api/utils/ErrorHandler';

const useHttpGetGoogleIntegrationOnMount = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<GoogleIntegration>();

    useEffect(() => {
        const { exec, abort } = userApi.getGoogleIntegration({
            onSuccess: res => setData(res.body),
            onFinally: () => setIsReady(true),
            onError: (error: AppError | string) => {
                // Only show error if it's not a "not found" error (which is expected)
                // If errorCode is RESOURCE_NOT_FOUND, it's expected and we don't show error
                if (!isErrorCode(error, ErrorCodes.RESOURCE_NOT_FOUND)) {
                    toastHandler.push('error', `An unexpected error has occurred.`);
                }
            },
        });
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetGoogleIntegrationOnMount;
